module.exports = __webpack_public_path__ + "img/max-white.svg";